import React from "react";
import { Users } from "lucide-react";

const SERIF = '"Cormorant Garamond", Georgia, serif';

// The one optional question before gifting. "Just send the gift" leaves the gift flow exactly as it was.
export const TogetherAsk = ({ journeyId, onJustGift }) => (
  <div className="pt-2" data-testid="together-ask">
    <h4 className="text-2xl" style={{ fontFamily: SERIF, color: "#F1ECDD" }}>Do this together for 21 days?</h4>
    <p className="mt-2 text-sm leading-relaxed" style={{ color: "rgba(241,236,221,0.72)" }}>
      Invite the people you share this with to follow the same installation and listening rhythm with you for 21 days.
    </p>
    <a href={`/together/new?j=${journeyId}`} data-testid="together-ask-start"
      className="mt-5 w-full rounded-full py-3.5 inline-flex items-center justify-center gap-2 text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-90"
      style={{ background: "#D7BB7A", color: "#0a132a" }}>
      <Users size={15} /> Start 21 Days Together
    </a>
    <button type="button" onClick={onJustGift} data-testid="together-ask-just-gift"
      className="mt-3 w-full rounded-full py-3 text-sm transition-colors hover:bg-white/5" style={{ border: "1px solid rgba(215,187,122,0.5)", color: "#D7BB7A" }}>
      Just send the gift
    </button>
  </div>
);
